import _set from "lodash/set";
import _each from "lodash/each";
import _clone from "lodash/clone";
import { createAsyncAction } from "./utils";
export var simulateVantageScore = createAsyncAction('simulateVantageScore', function (args, keyToStoreResponse, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      var simulations = _clone(args); // for security purposes, parse all inputs that are supposed to be numbers


      _each(simulations, function (value, key) {
        if (value !== true && value !== false) {
          simulations[key] = parseInt(value, 10);
        }
      });

      return opts.IdentitySDK.TUCreditReport.simulateVantageScore(simulations, serverRequest);
    },
    meta: {
      key: keyToStoreResponse
    },
    parseSuccess: function parseSuccess(resp) {
      // This is so we can run simulations but not mess with the simulation tab
      if (keyToStoreResponse) {
        return _set({}, keyToStoreResponse, resp.simulated_vantage_score || 0);
      }

      return resp;
    },
    parseFail: function parseFail() {
      if (keyToStoreResponse) {
        // Let's store a value so we disable the spinner
        return _set({}, keyToStoreResponse, 0);
      }

      return undefined;
    }
  };
});